import GeoStart from './GeoStart.vue'
import GeoStage from './GeoStage.vue'
import GeoAnalysis from './GeoAnalysis.vue'
import GeoReportGen from './GeoReportGen.vue'
import GeoReport from './GeoReport.vue'

export default {
  GeoStart,
  GeoStage,
  GeoAnalysis,
  GeoReportGen,
  GeoReport,
}
